export default "__VITE_ASSET__BmVCy_ix__"